module.exports = __webpack_public_path__ + "static/media/mongoDB.e7d230b7.svg";